<template>
  <ListeReferentiel
    ref="liste"
    titre="Fréquences de prise"
    icone="bi-arrow-repeat"
    ressource="frequences"
    tri-defaut="fre.nom"
    :options-tri="{ Nom: 'fre.nom' }"
    placeholder="Nom ou description…"
    unite="fréquence(s)"
    vide="Aucune fréquence enregistrée."
    :colonnes="5"
    :peut-creer="$store.getters.hasPermission('CONFIG_CREER_FREQUENCE')"
    libelle-creer="Nouvelle fréquence"
    @creer="creation"
  >
    <template #entete>
      <th>Nom</th>
      <th class="d-none d-md-table-cell">Description</th>
      <th>Statut</th>
      <th>Actions</th>
    </template>
    <template #ligne="{ ligne: freq }">
      <td>{{ freq.nom }}</td>
      <td class="d-none d-md-table-cell">{{ freq.description || '—' }}</td>
      <td>
        <span :class="['badge', freq.isEnabled ? 'bg-success' : 'bg-secondary']">{{ freq.isEnabled ? 'Activé' : 'Désactivé' }}</span>
      </td>
      <td>
        <div v-if="$store.getters.hasAnyPermission(['CONFIG_MODIFIER_FREQUENCE', 'CONFIG_SUPPRESSION_FREQUENCE'])" class="dropdown">
          <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" v-dropdown-fixed>Actions</button>
          <ul class="dropdown-menu">
            <li v-if="$store.getters.hasPermission('CONFIG_MODIFIER_FREQUENCE')"><a class="dropdown-item" href="#" @click.prevent="modifier(freq.id)">Modifier</a></li>
            <li v-if="$store.getters.hasPermission('CONFIG_SUPPRESSION_FREQUENCE')"><a class="dropdown-item text-danger" href="#" @click.prevent="supprimer(freq)">Supprimer</a></li>
          </ul>
        </div>
      </td>
    </template>
  </ListeReferentiel>
</template>

<script>
import ListeReferentiel from '@/components/commun/ListeReferentiel.vue';

export default {
  name: 'ListeFrequence',
  components: { ListeReferentiel },
  methods: {
    creation() {
      this.$router.push({ name: 'create_frequence' });
    },
    modifier(id) {
      this.$router.push({ name: 'edit_frequence', params: { id } });
    },
    supprimer(freq) {
      this.$refs.liste.supprimer({
        id: freq.id,
        titre: 'Supprimer la fréquence',
        message: `Supprimer la fréquence « ${freq.nom} » ?`,
        succes: 'Fréquence supprimée.',
      });
    },
  },
};
</script>
